import gql from 'graphql-tag';

export const MRO_SAVE_SEARCH_WORDS = gql`
  mutation SaveSearchWords($words: String!, $limit: Int!, $offset: Int!, $catalog_type: Int, $organization_id: uuid, $category_id: uuid, $country: String) {
    insert_search_statistics(objects: {words: $words, offset: $offset, limit: $limit, organization_id: $organization_id, catalog_type: $catalog_type, category_id: $category_id, country: $country}) {
      affected_rows
      __typename
    }
  }
`;

export const NEW_SAVE_SEARCH_WORDS = gql`
mutation NEW_SAVE_SEARCH_WORDS($catalog_type: Int = 2, $category_id: uuid, $country: String = "CL", $limit: Int!, $offset: Int!, $organization_id: uuid, $words: String!) {
  newSearchStatistics: insert_search_statistics(objects: {words: $words, offset: $offset, limit: $limit, organization_id: $organization_id, catalog_type: $catalog_type, category_id: $category_id, country: $country}) {
    affected_rows
    returning {
      id
    }
  }
}
`;

export const MRO_SAVE_ITEM_VISIT = gql`
  mutation SaveItemVisit($itemId: uuid!) {
    insert_item_visits(objects: {item_id: $itemId}) {
      affected_rows
      __typename
    }
  }
`;

export const MRO_INSERT_INFORMATION_RESPONSES = gql`mutation MRO_INSERT_INFORMATION_RESPONSES($data: [information_response_insert_input!]!) {
  insert_information_response(objects: $data) {
    returning {
      id
    }
  }
}`;



// WEBPACK FOOTER //
// ./src/store/graphql/mutations/cat4mro.js